import { memo } from 'react'
import './index.scss'
import LicencePlate from '../../../../../components/LicencePlate'
import Icon from '../../../../../components/Icon'
import { COLOR } from '../../../../../data/variables'
import { DTO_MaintenanceBase } from '../../../../../services/calls/types/maintenance'

type InstanceInfo = {
  label: string
  description: string
  icon: string
}

type InstanceTitle = {
  instanceInfo: InstanceInfo
  mobile: DTO_MaintenanceBase
}

const InstanceTitle = memo(({ instanceInfo, mobile }: InstanceTitle) => {
  const { label, description, icon } = instanceInfo

  return (
    <div className="InstanceTitle">
      <div className="InstanceTitle__mobile">
        <LicencePlate label={mobile.globalid} />
      </div>
      <div className="InstanceTitle__title">
        <Icon icon={icon} color={COLOR.RED_80} />
        <div className="InstanceTitle__title-text">
          <div className="InstanceTitle__title-text__main">{label}</div>
          <div className="InstanceTitle__title-text__sub">{description}</div>
        </div>
      </div>
    </div>
  )
})

export default InstanceTitle
